<template>
  <v-flex xs6 sm4 md3 lg2 class="page pa-3" style="cursor: pointer; position: relative">
    <BotLogoManager :bot="bot">
      <template #logo="{ pageLogo }">
        <v-responsive :aspect-ratio="1 / 1" class="page-image" @click="onSelectedBot(bot)">
          <img
            :src="pageLogo"
            :alt="bot.pagename"
            :title="bot.pagename"
            style="width: 100%; border-radius: 10px"
            @error="onImgError"
          />
        </v-responsive>
      </template>
    </BotLogoManager>
    <div
      class="page-name text-xs-center white--text mt-2 mb-2 text-truncate"
      :title="bot.pagename"
      @click="onSelectedBot(bot)"
    >
      {{ bot.pagename }}
    </div>
    <template v-if="isZwizAdmin()">
      <v-btn
        icon
        fab
        color="info"
        depressed
        small
        class="extra-small"
        style="position: absolute; left: 0; top: 0"
        @click="
          showDialogPageInfo = true
          currentPageInfo = bot
        "
      >
        <v-icon>info</v-icon>
      </v-btn>
      <v-btn
        v-clipboard:copy="bot.pageid"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        fab
        color="primary"
        depressed
        small
        class="extra-small"
        style="position: absolute; right: 0; top: 0"
      >
        <v-icon>file_copy</v-icon>
      </v-btn>
    </template>

    <v-dialog v-model="showDialogPageInfo" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title> Page Info </v-card-title>

        <v-card-text>
          <table v-if="currentPageInfo" class="zw-table fullwidth strip border-radius outline">
            <thead>
              <tr>
                <td>Key</td>
                <td>Value</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Page ID</td>
                <td>
                  {{ currentPageInfo.pageid }}
                </td>
              </tr>
              <tr>
                <td>Page ID</td>
                <td>
                  {{ currentPageInfo.theme }}
                </td>
              </tr>
            </tbody>
          </table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="
              showDialogPageInfo = false
              currentPageInfo = null
            "
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
      >{{ $t('Link Copied') }}!</v-snackbar
    >
  </v-flex>
</template>

<script>
import { PAGE } from '@/constants/page.js'
import { mapGetters } from 'vuex'
import BotLogoManager from '@/components/elements/BotLogoManager'
import { AM_DRMEK_ALL_IN_ONE_CHAT_MANAGE } from '@/constants/access-menu.js'
export default {
  components: {
    BotLogoManager
  },
  props: ['bot'],
  data: () => ({
    showDialogPageInfo: false,
    currentPageInfo: {},
    showCopy: false
  }),
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    isAMDrMekAllInOnePage() {
      if (Object.keys(AM_DRMEK_ALL_IN_ONE_CHAT_MANAGE).includes(this.selectedBot.pageid)) {
        const currentUser = AM_DRMEK_ALL_IN_ONE_CHAT_MANAGE[this.selectedBot.pageid]
        return currentUser && currentUser.includes(this.$store.state.userid)
      } else {
        return false
      }
    }
  },
  methods: {
    onCopy: function () {
      let vm = this
      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 1000)
    },

    onError: function () {},
    onImgError: function (event) {
      event.target.src = '/static/img/assets/livechat/profile.png'
    },
    onSelectedBot: function (bot) {
      try {
        this.$store.dispatch('selectBot', bot)
        var menubypageid = this.$store.state.menubypageid
        var pageid = this.selectedBot.pageid
        var theme = this.selectedBot.theme
        var privilege = this.$store.state.privilege
      } catch (error) {
        console.error(error)
      }

      if (menubypageid[pageid]) {
        this.$router.push(menubypageid[pageid][0])
      } else if (
        this.selectedBot.theme == 'seagull' &&
        ['warehouse'].includes(this.$store.state.privilege.role)
      ) {
        this.$router.push('template')
      } else if (
        PAGE.MORDEE.includes(this.selectedBot.pageid) &&
        ['admin'].includes(this.$store.state.privilege.role)
      ) {
        this.$router.push('allinonechat')
      } else if (
        PAGE.KMB_AGENT.includes(this.selectedBot.pageid) &&
        this.$store.state.privilege.role &&
        ['agent', 'supervisor'].includes(this.$store.state.privilege.role)
      ) {
        this.$router.push('ticket3/checkin')
      } else if (
        this.selectedBot.type == 'uu' &&
        ['agent_aya01', 'agent_aya02', 'agent_takhli01', 'agent_takhli02'].includes(
          this.$store.state.userid
        )
      ) {
        this.$router.push('broadcast')
      } else if (['amaze'].includes(this.selectedBot.type)) {
        return this.$router.push('welcome')
      } else if (theme == 'powerbuy') {
        if (privilege && privilege.role) {
          if (privilege.role == 'admin') {
            this.$router.push('PowerbuyFacebookPostManager')
          } else if (privilege.role == 'agency') {
            this.$router.push('comment')
          } else {
            // before check only privilege.role == 'superadmin'
            // It's affected to other role, make to ignore to redirect to any view
            this.$router.push('PowerbuyManagement')
          }
        } else {
          this.$router.push('PowerbuyManagement')
        }
      } else if (
        this.$store.state.toacustomerpage.includes(pageid) &&
        ['TOAadminliveChat01', 'TOAadminliveChat02'].includes(this.$store.state.userid)
      ) {
        this.$router.push('allinonechat')
      } else if (theme == 'universalutilities') {
        this.$router.push('dashboard')
      } else if (['studio7', 'ustore', 'ticket2'].includes(theme)) {
        if (privilege.role == 'chatbot') {
          this.$router.push('welcome')
        } else {
          this.$router.push('ticket2profile')
        }
      } else if (['cityfresh'].includes(theme)) {
        this.$router.push('CityFreshprofile')
      } else if (['kingkitchen'].includes(theme)) {
        this.$router.push('KingkitchenAdminMenu')
      } else if (theme == 'toacrm' || theme == 'toaecoupon') {
        return this.$router.push('template')
      } else if (
        theme == 'ticket' ||
        this.$store.state.ticketPageid.includes(this.selectedBot.pageid) ||
        this.$store.state.ticketThemeList.includes(this.selectedBot.theme)
      ) {
        if (['208321456497173'].includes(pageid) /* AIS FIBRE */) {
          this.$router.push('allinonechat')
        } else if (
          this.$store.state.nestlePages.some((page) => page.pageid == this.selectedBot.pageid) &&
          this.nestleAcommerceGroup
        ) {
          return this.$router.push('template')
        } else if (['mordee'].includes(this.selectedBot.type)) {
          return this.$router.push('welcome')
        } else {
          return this.$router.push('ticket')
        }
      } else if (theme == 'secap') {
        this.$router.push('secap-maintenance-service-booking')
      } else if (['yasale-ac'].includes(this.selectedBot.type)) {
        return this.$router.push('yasale-ac-admin-menu')
      } else if (['nongtungjai'].includes(this.selectedBot.type)) {
        return this.$router.push('nongtungjai/patient-history')
      } else if (this.selectedBot.theme === 'loligo' || this.selectedBot.theme == 'letussea') {
        if (privilege.role === 'agent') {
          this.$router.push('allinonechat')
        } else {
          this.$router.push('welcome')
        }
      } else if (this.selectedBot.type === 'delta') {
        if (this.$store.state.privilege.role === 'admin') {
          this.$router.push('allinonechat')
        } else {
          this.$router.push('welcome')
        }
      } else if (this.isAMDrMekAllInOnePage) {
        this.$router.push('allinonechat-new')
      } else {
        this.$router.push('welcome')
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/allbots/AccountItem.vue